<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="center">Originally published by Ace Books, a division of Penguin Putnam, in October 1998.<br/>Published as an ebook by Jabberwocky Literary Agency in June 2011.</p>
<p class="center">All rights reserved.<br/>Copyright © 1998 by Rick Shelley.<br/>Cover art by Dirk Berger.<br/>This book may not be reproduced in whole or in part, by mimeograph or any other means, without permission.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0441005683_epub_cop_r1.vue?0f8f88ea